import axios from "axios";

export const DIRECT_GRBAS_CONSUMER_CONTEXT =
  "DIRECT_ENGINE_GRBAS_PRACTICE";

export async function issueEngineMediaDescriptor({
  apiUrl,
  token,
  sessionId,
  trialId,
  consumerContext,
}) {
  const response = await axios.post(
    `${apiUrl}/evaluation/session/${sessionId}/trial/${trialId}/media-descriptor`,
    { consumerContext },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data.descriptor;
}

export async function issuePublishedAssignmentMediaDescriptor({
  apiUrl,
  token,
  assignmentId,
  sessionId,
  trialId,
  consumerContext,
}) {
  const response = await axios.post(
    `${apiUrl}/assignments/assigned/${assignmentId}/session/${sessionId}/trial/${trialId}/media-descriptor`,
    { consumerContext },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data.descriptor;
}

export function validateEngineMediaDescriptor(
  descriptor,
  stimulusInstanceId,
  consumerContext,
  evaluationTime = Date.now()
) {
  return Boolean(descriptor)
    && descriptor.descriptorVersion === "authorized_media_descriptor.v1"
    && descriptor.mediaRef?.canonicalId ===
      `stimulus-instance:${stimulusInstanceId}`
    && descriptor.consumerContext === consumerContext
    && descriptor.transportKind === "PRESIGNED_PRIVATE_OBJECT"
    && descriptor.refreshMode === "REAUTHORIZE_SAME_MEDIA"
    && typeof descriptor.playbackUrl === "string"
    && /^https:\/\//.test(descriptor.playbackUrl)
    && Number.isFinite(Date.parse(descriptor.expiresAt))
    && Date.parse(descriptor.expiresAt) > evaluationTime;
}
